import { Icon } from "components";
import { badgeContainer } from "./badgeContainer";
import Svg from "assets/svg"
interface BadgeProps {
    type: "low" | "medium" | "high"
}
export const SimpleBadge = ({ type }: BadgeProps) => {
    const { base } = badgeContainer({ type })
    const icon = {
        low: { icon: '', label: 'low' },
        medium: { icon: 'zap', label: 'medium' },
        high: { icon: 'fire', label: 'high' }
    }
    return <button className={base()}>
        {type === 'low' ? <Svg.snail /> : <Icon name={icon[type].icon} size={17} />}
        {icon[type].label}
    </button>
}